export enum EInvoiceExemptTvaZone {
  France = 0,
  OutreMerDepartements = 1,
  OutreMerTerritories = 2,
  EuropeenUnion = 3,
}
